export default class AlertModel {
  alertState!: boolean;
  alertType!: string;
  alertMessage!: string;
}
